import { render, staticRenderFns } from "./CountryDisplay.vue?vue&type=template&id=09e917c6&scoped=true"
import script from "./CountryDisplay.vue?vue&type=script&lang=js"
export * from "./CountryDisplay.vue?vue&type=script&lang=js"
import style0 from "./CountryDisplay.vue?vue&type=style&index=0&id=09e917c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e917c6",
  null
  
)

export default component.exports